'use strict';

module Patersons {

    export class CsvBuilder {
        private filename: string;
        private topLine: string;
        private headers: string[];
        private fields: string[];
        private data: any[];

        constructor() {
            this.filename = this.generateDefaultFilename();
            this.headers = new Array<string>();
            this.data = new Array<any[]>();
        }

        public setFilename(filename: string): CsvBuilder {
            if (filename !== null && filename !== undefined) {
                this.filename = filename;
            }

            return this;
        }

        public setTopLine(topLine: string): CsvBuilder {
            this.topLine = topLine;
            return this;
        }

        public setHeaders(headers: string[]): CsvBuilder {
            this.headers = headers;
            return this;
        }

        public setData(data: any[][]): CsvBuilder {
            this.data = data;
            return this;
        }

        public build(): void {
            let blob: Blob = this.createCsvFile(this.headers, this.data);
            this.makeCsv(blob);
        }

        private makeCsv(csvBlob: Blob): void {
            this.filename += '.csv';
            this.saveFile(this.filename, csvBlob)
        }

        private saveFile (name, data) {
            if (data !== null && navigator.msSaveBlob)
                return navigator.msSaveBlob(data, name);
            var a = $("<a style='display: none;'/>");
            var url = window.URL.createObjectURL(data);
            a.attr("href", url);
            a.attr("download", name);
            $("body").append(a);
            a[0].click();
            window.URL.revokeObjectURL(url);
            a.remove();
        }

        private createCsvFile(headers: string[], data: any[]) {
            let EOL: string = '\r\n';
            let csvContent: string = "";
            if (this.topLine != null) {
                csvContent = '"' + this.topLine + '"' + EOL;
            }
            csvContent = csvContent + headers.
                map(header => '"' + header + '"').
                join(',') + EOL;

            for (let row of data) {
                let rowItems: any[] = [];

                for (let field of row) {
                    let val: any = field;

                    if (typeof val === 'string') {
                        val = val.replace(/"/g, '""');
                    }

                    if (typeof val === 'number') {
                        rowItems.push(val);
                    } else {
                        rowItems.push('"' + val + '"');
                    }
                }

                csvContent += rowItems.join(',') + EOL;
            }

            return new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
        }

        private generateDefaultFilename(): string {
            // Generate a pseudorandom 16-character string using [0-9a-z].
            let randomString: string = (Math.random().toString(36) + '00000000000000000').slice(2, 18);
            let timeStamp: Date = new Date();

            return randomString + '-' + timeStamp.toISOString();
        }
    }
}
